'use strict';
var REGEXP = /^[A-Za-z0-9._%+\-!#$&'\*/=\?\^`{\|}~]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,20}$/;

class EmailDirective {
    restrict = 'A';
    require = 'ngModel';
    scope = {};

    link(scope, element, attr, ngModelCtrl) {
        ngModelCtrl.$parsers.push(function (viewValue) {
            if (!viewValue || REGEXP.test(viewValue)) {
                ngModelCtrl.$setValidity('email', true);
                return viewValue;
            }
            ngModelCtrl.$setValidity('email', false);
            return undefined;
        });
    }
}

export let email:any = () => new EmailDirective();



// WEBPACK FOOTER //
// ./src/main/ui/core/directives/validation/email.directive.ts